<template>
  <div
    style="
      width: 100%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-item: center;
    "
  >
    <div
      style="
        width: 400px;
        height: 210px;
        border: 1px solid #409eff;
        border-radius: 20px;
        padding: 20px;
      "
    >
      <h1>Accedi</h1>
      <el-form :model="loginData" label-width="100px">
        <el-form-item label="Nome utente">
          <el-input
            v-model="loginData.username"
            @keyup.enter="onSubmit"
          />
        </el-form-item>
        <el-form-item label="Password">
          <el-input
            v-model="loginData.password"
            type="password"
            placeholder="Inserire password"
            show-password
            @keyup.enter="onSubmit"
          />
        </el-form-item>

        <el-form-item style="text-align: center; margin-left: 0px">
          <el-button type="primary" :loading="isLoading" @click="onSubmit">
            Accedi
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { reactive, ref, toRaw } from 'vue';
import { ElMessage } from 'element-plus';
import searchAPI from './../services/searchAPI';
import { isLoggedStore } from '@/store/logged';
import crypto from './../services/crypto';
export default {
  setup() {
    const router = useRouter();
    const store = isLoggedStore();
    const loginData = reactive({
      username: '',
      password: '',
    });
    const isLoading = ref(false);

    const onSubmit = async () => {
      if (isLoading.value) return;
      if (!loginData.username || !loginData.password) {
        ElMessage.warning('Inserisci nome utente e password');
        return;
      }
      isLoading.value = true;
      try {
        const response = await searchAPI.login(toRaw(loginData));
        if (response.status === 201) {
          store.isLogged = true;
          store.nome = response.data.nome;
          store.tipo = crypto.cipher(response.data.tipo);
          store.user = loginData.username;
          store.viewMenu = true;
          router.push('/');
        } else {
          ElMessage.error('Errore inatteso durante il login');
        }
      } catch (e) {
        if (e.response && e.response.status === 401) {
          ElMessage.error('Nome utente o password errati');
        } else {
          ElMessage.error(
            'Impossibile contattare il server, riprova tra qualche istante'
          );
        }
      } finally {
        isLoading.value = false;
      }
    };

    const annulla = () => {
      router.push(`/details/`);
    };

    return {
      loginData,
      onSubmit,
      annulla,
      isLoading,
    };
  },
};
</script>
